import config from './config';
const API_AUTH = config.TUUTUUM_BACKEND_ADMIN_API + "/auth";
const API_USERS = config.TUUTUUM_BACKEND_ADMIN_API + "/users";
const API_USER_DETAILS = config.TUUTUUM_BACKEND_ADMIN_API + "/users/"
const API_BEARERS = config.TUUTUUM_BACKEND_ADMIN_API + "/bearers";
const API_SCAN_TOKENS = config.TUUTUUM_BACKEND_ADMIN_API + "/scan_tokens";
const API_DISEASES = config.TUUTUUM_BACKEND_ADMIN_API + "/diseases";
const API_EMERGENCY_CONTACTS = config.TUUTUUM_BACKEND_ADMIN_API + "/emergency-contacts";

async function authenticate(username, password) {
	try {
		let response = await fetch(API_AUTH , {
				headers: {
					'content-type': 'application/json',
				},
				method: `POST`,
				mode: `cors`,
				body: JSON.stringify({
						"name":username,
						"password":password
					}),
			});
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					status: false,
					msg: data.msg
				};
			} else {
				throw("Invalid JSON data from server!");
			}
		}
		const response_data = await response.json();
		return {
			status: true,
			msg: response_data.msg,
			data: response_data.data
		}
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}

async function get_users(token, filter = '') {
	try {
		// TODO: Handle filter parameters
		const URL = API_USERS + (filter ? "?filter=" + filter : "");
		let response = await fetch(URL , {
				headers: {
					'content-type': 'application/json',
					'Authorization': token
				},
				method: `GET`,
				mode: `cors`
			});
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					status: false,
					msg: data.msg
				};
			} else {
				throw("Invalid JSON data from server!");
			}
		}
		const response_data = await response.json();
		return {
			status: true,
			msg: response_data.msg,
			data: response_data.data
		}
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}

async function get_user_details(token, user_id) {
	try {
		const URL = API_USER_DETAILS + user_id;
		let response = await fetch(URL , {
				headers: {
					'content-type': 'application/json',
					'Authorization': token
				},
				method: `GET`,
				mode: `cors`
			});
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					status: false,
					msg: data.msg
				};
			} else {
				throw("Invalid JSON data from server!");
			}
		}
		const response_data = await response.json();
		return {
			status: true,
			msg: response_data.msg,
			data: response_data.data
		}
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}

async function update_user(token, user_id, request_body) {
	try {
		let response = await fetch(API_USERS + "/" + user_id , {
				headers: {
					'content-type': 'application/json',
					'Authorization': token
				},
				method: `PUT`,
				mode: `cors`,
				body: JSON.stringify(request_body)
			});
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					success: false,
					msg: data.msg
				};
			} else {
				throw("Invalid JSON data from server!");
			}
		}
		const response_data = await response.json();
		return {
			success: true,
			msg: response_data.msg,
		}
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}

async function delete_user(token, user_id) {
	try {
		let response = await fetch(API_USERS + "/" + user_id , {
				headers: {
					'content-type': 'application/json',
					'Authorization': token
				},
				method: `DELETE`,
				mode: `cors`,
			});
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					success: false,
					msg: data.msg
				};
			} else {
				throw("Invalid JSON data from server!");
			}
		}
		const response_data = await response.json();
		return {
			success: true,
			msg: response_data.msg,
		}
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}

async function get_bearers(token, user_id) {
	try {
		const URL = API_USERS + '/' + user_id + '/bearers';
		let response = await fetch(URL , {
				headers: {
					'content-type': 'application/json',
					'Authorization': token
				},
				method: `GET`,
				mode: `cors`
			});
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					status: false,
					msg: data.msg
				};
			} else {
				throw("Invalid JSON data from server!");
			}
		}
		const response_data = await response.json();
		return {
			status: true,
			msg: response_data.msg,
			data: response_data.data
		}
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}

async function create_bearer(token, name, is_verbal = true) {
	try {
		let data;
		let response = await fetch(API_BEARERS , {
				headers: {
					'content-type': 'application/json',
					'Authorization': token
				},
				method: `POST`,
				mode: `cors`,
				body: JSON.stringify({
							"name":			name,
							"is_verbal":	is_verbal
						}),
			});
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					success: false,
					msg: data.msg
				};
			} else {
				const msg = "Invalid JSON data from server!";
				console.log(msg);
				throw(msg);
			}
		}
		const response_data = await response.json();
		console.log("  Create bearer response from server: " + JSON.stringify(response_data));
		return {
			success: true,
			msg: response_data.msg,
			id: response_data.id
		}
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}

async function get_bearer(token, bearer_id) {
	try {
		const URL = API_BEARERS + "/" + bearer_id;
		let response = await fetch(URL , {
				headers: {
					'content-type': 'application/json',
					'Authorization': token
				},
				method: `GET`,
				mode: `cors`
			});
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					status: false,
					msg: data.msg
				};
			} else {
				throw("Invalid JSON data from server!");
			}
		}
		const response_data = await response.json();
		return {
			status: true,
			msg: response_data.msg,
			data: response_data.data
		}
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}

async function update_bearer(token, bearer_id, request_body) {
	try {
		let response = await fetch(API_BEARERS + "/" + bearer_id , {
				headers: {
					'content-type': 'application/json',
					'Authorization': token
				},
				method: `PUT`,
				mode: `cors`,
				body: JSON.stringify(request_body)
			});
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					success: false,
					msg: data.msg
				};
			} else {
				throw("Invalid JSON data from server!");
			}
		}
		const response_data = await response.json();
		return {
			success: true,
			msg: response_data.msg,
		}
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}

async function delete_bearer(token, bearer_id) {
	try {
		let response = await fetch(API_BEARERS + "/" + bearer_id , {
				headers: {
					'content-type': 'application/json',
					'Authorization': token
				},
				method: `DELETE`,
				mode: `cors`,
			});
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					success: false,
					msg: data.msg
				};
			} else {
				throw("Invalid JSON data from server!");
			}
		}
		const response_data = await response.json();
		return {
			success: true,
			msg: response_data.msg,
		}
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}

async function get_bearer_audit_log(token, bearer_id) {
	try {
		const URL = API_BEARERS + '/' + bearer_id + '/audit';
		let response = await fetch(URL, {
			headers: {
				'content-type': 'application/json',
				'Authorization': token
			},
			method: 'GET',
			mode: 'cors'
		});
		if (!response.ok) {
			const data = await response.json();
			return { success: false, msg: data.msg || 'Failed to fetch audit log' };
		}
		const response_data = await response.json();
		return {
			success: true,
			data: response_data.data || []
		};
	} catch(err) {
		console.log("fetch exception: " + err);
		throw(err);
	}
}

async function get_bearer_access_log(token, bearer_id) {
	try {
		const URL = API_BEARERS + '/' + bearer_id + '/access-log';
		let response = await fetch(URL, {
			headers: {
				'content-type': 'application/json',
				'Authorization': token
			},
			method: 'GET',
			mode: 'cors'
		});
		if (!response.ok) {
			const data = await response.json();
			return { success: false, msg: data.msg || 'Failed to fetch access log' };
		}
		const response_data = await response.json();
		return {
			success: true,
			data: response_data.data || []
		};
	} catch(err) {
		console.log("fetch exception: " + err);
		throw(err);
	}
}

async function get_user_access_log(token, user_id) {
	try {
		const URL = API_USERS + '/' + user_id + '/access-log';
		let response = await fetch(URL, {
			headers: {
				'content-type': 'application/json',
				'Authorization': token
			},
			method: 'GET',
			mode: 'cors'
		});
		if (!response.ok) {
			const data = await response.json();
			return { success: false, msg: data.msg || 'Failed to fetch access log' };
		}
		const response_data = await response.json();
		return {
			success: true,
			data: response_data.data || []
		};
	} catch(err) {
		console.log("fetch exception: " + err);
		throw(err);
	}
}

async function get_scan_tokens(token, bearer_id) {
	console.log("Getting scan tokens for bearer " + bearer_id);
	try {
		const URL = API_BEARERS + '/' + bearer_id + '/scan_tokens';
		console.log("  URL: " + URL);
		let response = await fetch(URL , {
				headers: {
					'content-type': 'application/json',
					'Authorization': token
				},
				method: `GET`,
				mode: `cors`
			});
		console.log("  Fetch completed : " + response);
		console.log("  Response: " + JSON.stringify(response));
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					status: false,
					msg: data.msg
				};
			} else {
				throw("Invalid JSON data from server!");
			}
		}
		const response_data = await response.json();
		return {
			status: true,
			msg: response_data.msg,
			data: response_data.data ?? response_data.tokens
		}
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}

async function update_scan_token(login_token, scan_token, update_fields) {
	try {
		let response = await fetch(API_SCAN_TOKENS + "/" + scan_token , {
				headers: {
					'content-type': 'application/json',
					'Authorization': login_token
				},
				method: `PUT`,
				mode: `cors`,
				body: JSON.stringify(update_fields)
			});
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					success: false,
					msg: data.msg
				};
			} else {
				throw("Invalid JSON data from server!");
			}
		}
		const response_data = await response.json();
		return {
			success: true,
			msg: response_data.msg,
		}
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}

async function get_scans(login_token, scan_token) {
	try {
		let response = await fetch(API_SCAN_TOKENS + "/" + scan_token + '/scans', {
				headers: {
					'content-type': 'application/json',
					'Authorization': login_token
				},
				method: `GET`,
				mode: `cors`
			});
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					status: false,
					msg: data.msg
				};
			} else {
				throw("Invalid JSON data from server!");
			}
		}
		const response_data = await response.json();
		return {
			status: true,
			msg: response_data.data,
		}
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}

/**
 * 
 */
async function get_disease(login_token, disease_id) {
	try {
		let response = await fetch(API_DISEASES + "/" + disease_id, {
				headers: {
					'content-type': 'application/json',
					'Authorization': login_token
				},
				method: `GET`,
				mode: `cors`
			});
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					status: false,
					msg: data.msg
				};
			} else {
				throw("Invalid JSON data from server!");
			}
		}
		const response_data = await response.json();
		return {
			status: true,
			id: response_data.id,
			name: response_data.name
		}
		return { status: true };
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}

/**
 * Get all diseases
 */
async function get_diseases(login_token) {
	try {
		let response = await fetch(API_DISEASES, {
				headers: {
					'content-type': 'application/json',
					'Authorization': login_token
				},
				method: `GET`,
				mode: `cors`
			});
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					status: false,
					msg: data.msg
				};
			} else {
				throw("Invalid JSON data from server!");
			}
		}
		const response_data = await response.json();
		return {
			status: true,
			data: response_data.data,
		}
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}

/**
 * Save diseases list
 */
async function post_diseases(login_token, diseases) {
	try {
		let response = await fetch(API_DISEASES, {
				headers: {
					'content-type': 'application/json',
					'Authorization': login_token
				},
				method: `POST`,
				mode: `cors`,
				body: JSON.stringify(diseases)
			});
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					status: false,
					msg: data.msg
				};
			} else {
				throw("Invalid JSON data from server!");
			}
		}
		const response_data = await response.json();
		return {
			status: true,
			count: response_data.count,
		}
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}

/**
 * Returns the number of scan tokens created
 */
async function post_scan_tokens(login_token, no_tokens) {
	try {
		let response = await fetch(API_SCAN_TOKENS + "?count=" + no_tokens, {
				headers: {
					'content-type': 'application/json',
					'Authorization': login_token
				},
				method: `POST`,
				mode: `cors`
			});
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					status: false,
					msg: data.msg
				};
			} else {
				throw("Invalid JSON data from server!");
			}
		}
		const response_data = await response.json();
		return {
			status: true,
			count: response_data.tokens_created,
		}
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}


async function get_number_of_unused_scan_tokens(token) {
	let data;
	try {
		let response = await fetch(API_SCAN_TOKENS + "?count=0" , {
				headers: {
					'content-type': 'application/json',
					'Authorization': token
				},
				method: `GET`,
				mode: `cors`,
			});
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					success: false,
					msg: data.msg
				};
			} else {
				const msg = "Invalid JSON data from server!";
				console.log(msg);
				throw(msg);
			}
		}
		const response_data = await response.json();
		return {
			success: true,
			tokens_unused: response_data.tokens_unused
		}
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}

async function get_unused_scan_tokens(token, count = 1) {
	let data;
	try {
		let response = await fetch(API_SCAN_TOKENS + "?count=" + count , {
				headers: {
					'content-type': 'application/json',
					'Authorization': token
				},
				method: `GET`,
				mode: `cors`,
			});
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					success: false,
					msg: data.msg
				};
			} else {
				const msg = "Invalid JSON data from server!";
				console.log(msg);
				throw(msg);
			}
		}
		const response_data = await response.json();
		console.log("data: " + JSON.stringify(response_data));
		return {
			success: true,
			data: response_data.tokens_unused,
		}
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}

async function mark_scan_code_as_printed(loginToken, scanToken, printerUserId) {
	if(!printerUserId) {
		throw "No user provided!";
	}
	if(!scanToken) {
		throw "No scan token provided!";
	}
	console.log("Marking scan token " + scanToken + " as printed by " + printerUserId);

	const update_fields = { printer_id: printerUserId };

	try {
		let response = await fetch(API_SCAN_TOKENS + "/" + scanToken , {
				headers: {
					'content-type': 'application/json',
					'Authorization': loginToken
				},
				method: `PUT`,
				mode: `cors`,
				body: JSON.stringify(update_fields)
			});
		if (!response.ok) {
			const data = await response.json();
			if(data?.status !== undefined) {
				return {
					success: false,
					msg: data.msg
				};
			} else {
				throw("Invalid JSON data from server!");
			}
		}
		const response_data = await response.json();
		return {
			success: true,
			msg: response_data.msg,
		}
	} catch(err) {
		const msg = "fetch exception: " + err;
		console.log(msg);
		throw(msg);
	}
}

export {
	authenticate,
	get_users,
	get_user_details,
	update_user,
	delete_user,
	get_bearers,
	create_bearer,
	get_bearer,
	update_bearer,
	delete_bearer,
	get_bearer_audit_log,
	get_bearer_access_log,
	get_user_access_log,
	get_scan_tokens,
	update_scan_token,
	get_scans,
	get_disease,
	get_diseases,
	post_diseases,
	get_number_of_unused_scan_tokens,
	post_scan_tokens,
	get_unused_scan_tokens,
	mark_scan_code_as_printed,
	get_emergency_contacts,
	create_emergency_contact,
	update_emergency_contact,
	delete_emergency_contact
};

// Emergency Contacts API
async function get_emergency_contacts(token) {
	try {
		let response = await fetch(API_EMERGENCY_CONTACTS, {
			headers: {
				'content-type': 'application/json',
				'Authorization': 'Bearer ' + token
			},
			method: 'GET',
			mode: 'cors'
		});
		if (!response.ok) {
			const data = await response.json();
			return { success: false, msg: data.msg || 'Failed to fetch emergency contacts' };
		}
		const response_data = await response.json();
		return {
			success: true,
			msg: response_data.msg,
			data: response_data.data
		};
	} catch(err) {
		console.log("fetch exception: " + err);
		throw(err);
	}
}

async function create_emergency_contact(token, phone, description, is_primary = false) {
	try {
		let response = await fetch(API_EMERGENCY_CONTACTS, {
			headers: {
				'content-type': 'application/json',
				'Authorization': 'Bearer ' + token
			},
			method: 'POST',
			mode: 'cors',
			body: JSON.stringify({ phone, description, is_primary })
		});
		if (!response.ok) {
			const data = await response.json();
			return { success: false, msg: data.msg || 'Failed to create emergency contact' };
		}
		const response_data = await response.json();
		return {
			success: true,
			msg: response_data.msg,
			data: response_data.data
		};
	} catch(err) {
		console.log("fetch exception: " + err);
		throw(err);
	}
}

async function update_emergency_contact(token, contactId, updates) {
	try {
		let response = await fetch(`${API_EMERGENCY_CONTACTS}/${contactId}`, {
			headers: {
				'content-type': 'application/json',
				'Authorization': 'Bearer ' + token
			},
			method: 'PUT',
			mode: 'cors',
			body: JSON.stringify(updates)
		});
		if (!response.ok) {
			const data = await response.json();
			return { success: false, msg: data.msg || 'Failed to update emergency contact' };
		}
		const response_data = await response.json();
		return {
			success: true,
			msg: response_data.msg,
			data: response_data.data
		};
	} catch(err) {
		console.log("fetch exception: " + err);
		throw(err);
	}
}

async function delete_emergency_contact(token, contactId) {
	try {
		let response = await fetch(`${API_EMERGENCY_CONTACTS}/${contactId}`, {
			headers: {
				'content-type': 'application/json',
				'Authorization': 'Bearer ' + token
			},
			method: 'DELETE',
			mode: 'cors'
		});
		if (!response.ok) {
			const data = await response.json();
			return { success: false, msg: data.msg || 'Failed to delete emergency contact' };
		}
		const response_data = await response.json();
		return {
			success: true,
			msg: response_data.msg
		};
	} catch(err) {
		console.log("fetch exception: " + err);
		throw(err);
	}
}
